import type {ReactElement} from 'react';

export enum AiGenerationListItemState {
  DEFAULT = 'default',
  GENERATING = 'generating',
  LOADING = 'loading',
}

export interface AiGenerationListItemProps {
  content?: ReactElement;
  state?: AiGenerationListItemState;
  onClick?: () => void;
  className?: string;
}
